import { ReactNode } from 'react';
import { Header } from './Header';
import { MobileDock, Sidebar } from './Sidebar';
import { NewActivityFlow } from '@/components/activities/NewActivityFlow';
import { PWAInstallPrompt } from '@/components/pwa/PWAInstallPrompt';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="app-shell flex h-dvh min-h-dvh flex-col overflow-hidden bg-background">
      <Header />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <Sidebar />
        <main className="native-scroll min-h-0 flex-1 overflow-auto px-3 pb-[calc(5rem+env(safe-area-inset-bottom,0px))] pt-3 sm:px-4 md:p-6">
          {children}
        </main>
      </div>
      <MobileDock />
      <NewActivityFlow />
      <PWAInstallPrompt />
    </div>
  );
}
